import React, { useMemo } from "react";

import { deriveShiftStatus, shiftCashVariance } from "../utils/shiftHelpers";
import { formatCurrency } from "@/utils/formatCurrency";

function Tile({ label, value, accent = "text-[#333333]" }) {
  return (
    <div className="flex flex-col gap-1 min-w-[160px]">
      <p className="text-sm text-[#666]">{label}</p>
      <span className={`text-[20px] font-semibold ${accent}`}>{value}</span>
    </div>
  );
}

export default function ShiftSummary({ shifts = [] }) {
  const stats = useMemo(() => {
    let open = 0;
    let unverified = 0;
    let variance = 0;

    shifts.forEach((shift) => {
      const status = deriveShiftStatus(shift);
      if (status === "open") open += 1;
      if (status === "closed") unverified += 1;
      const v = shiftCashVariance(shift);
      if (typeof v === "number") variance += v;
    });

    return { total: shifts.length, open, unverified, variance };
  }, [shifts]);

  const varianceAccent =
    stats.variance === 0
      ? "text-[#333333]"
      : stats.variance > 0
        ? "text-green-600"
        : "text-red-600";

  return (
    <div className="mb-6 rounded-lg bg-white border border-[#e4e4e4] px-5 py-4 shadow-sm">
      <div className="flex flex-wrap gap-8">
        <Tile label="Total Shifts" value={stats.total} />
        <Tile label="Open Now" value={stats.open} accent="text-amber-600" />
        <Tile label="Awaiting Verification" value={stats.unverified} accent="text-blue-600" />
        <Tile
          label="Net Cash Variance"
          value={`${stats.variance > 0 ? "+" : ""}${formatCurrency(stats.variance)}`}
          accent={varianceAccent}
        />
      </div>
    </div>
  );
}
